import React, { FC, useContext } from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFieldArray, useFormContext, useFormState } from 'react-hook-form';

import { IdeaFormContext } from 'buyside/components/presentation/IdeaForm/ideaForm';
import Position from 'buyside/components/presentation/IdeaForm/Positions/position';
import ResearchFormWizardSection from 'buyside/components/presentation/ResearchFormWizard/researchFormWizardSection';

import { IdeaFormInput } from 'buyside/util/researchSubmission';

import styles from './positionsStyles.scss';

const Positions: FC = () => {
  const { setValue } = useFormContext<IdeaFormInput>();

  const { isSubmitting } = useFormState();

  const { isDraft } = useContext(IdeaFormContext);

  const {
    fields: positionFields,
    append: addPositionField,
    remove: removePositionField,
    update: updatePositionField
  } = useFieldArray<IdeaFormInput, 'positions'>({
    name: 'positions'
  });

  const isPairTrade = positionFields.length === 2;

  return (
    <ResearchFormWizardSection title={isPairTrade ? 'Positions' : 'Position'}>
      <div className={styles.positions}>
        {positionFields.map(({ id, positionId }, index) => (
          <Position
            key={id}
            handleRemovePosition={() => {
              removePositionField(index);
              setValue('pairRatio', null, {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true
              });
              setValue('returnTarget', null, {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true
              });
            }}
            handleResetPosition={() =>
              updatePositionField(index, {
                assetId: '',
                direction: '',
                positionId,
                priceTarget: null,
                userDefinedAsset: null
              })
            }
            index={index}
            isDraft={isDraft}
            isPairTrade={isPairTrade}
          />
        ))}
        {isDraft && !isPairTrade ? (
          <button
            type="button"
            disabled={isSubmitting}
            onClick={() => {
              setValue('pairRatio', [1, 1], {
                shouldDirty: true,
                shouldTouch: true,
                shouldValidate: true
              });
              addPositionField({
                assetId: '',
                direction: '',
                positionId: '',
                priceTarget: null,
                userDefinedAsset: null
              });
            }}
          >
            <FontAwesomeIcon icon={faPlus} /> Pair Another Security
          </button>
        ) : null}
      </div>
    </ResearchFormWizardSection>
  );
};

export default Positions;
